import Layout from "@components/layout/Layout.vue";
// 政策页面
export default {
    path: "/guidelines",
    component: Layout,
    meta: {
        transition: "slide",
    },
    children: [{
            path: "index",
            component: () =>
                import ("@pages/guidelines/index.vue"),
        },
        {
            path: "detail",
            component: () =>
                import ("@pages/guidelines/detail.vue"),
        },
    ],
};